import PropTypes from 'prop-types'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import { Chips, CHIPS_COLOR, Link as LinkDS } from 'veloe-ds'
import BotaoCTA from '../BotaoCTA'
import {
  Anotacao,
  CardChips,
  CardLink,
  ContainerCard,
  ContainerText,
  CtaContainer,
  TextoCard,
  TituloCard,
} from '../Card/styles'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

const replaceVariableByValue = (v) => v

export default function Card(props) {
    const { card } = props;
    const transparent = props.transparent || card.transparent
    const { tabCard } = card
    function convert(str) {
        return parseISO(str.replace('T', ' '))
    }
    
    const lines = card.descricao?.split("<br>");

    return (
        <ContainerCard
            menor={props.menor}
            usarBorda={card.usarBorda}
            especial={card.especial}
            transparent={transparent}
            tabCard={tabCard}
            sizeCardImage={card.sizeCardImage}
        >
            {card.imagem && (
                <img
                    src={card.imagem.url}
                    alt={card.imagem.description}
                    title={card.imagem.title}
                />
            )}
            <ContainerText
                alinhamento={card.alinhamento}
                blog={props.blog}
                tamanhoListaCards={props.tamanhoListaCards}
            >
                {card.data && (
                    <CardChips>
                        <Chips
                            color={CHIPS_COLOR.INFO}
                            style={{ padding: '0 16px' }}
                            label={format(convert(card.data), 'MMMM, yyyy', {
                                locale: ptBR,
                            })}
                        />
                    </CardChips>
                )}

                {card.titulo && (
                    <TituloCard
                        alinhamento={card.alinhamento}
                        blog={props.blog}
                        corTexto={card.corTitulo}
                    >
                        {' '}
                        <ReactMarkdown>{card.titulo}</ReactMarkdown>{' '}
                    </TituloCard>
                )}
                {lines && lines[0] && (
                    <TextoCard
                        ellipsis={props.ellipsis}
                        alinhamento={card.alinhamento}
                        tabCard={tabCard}
                        corTexto={card.corTexto}
                    >
                        {' '}
                        {
                            typeof lines[0] === 'string' ? <ReactMarkdown>{lines[0]}</ReactMarkdown> : lines[0]
                        }
                        {' '}
                    </TextoCard>
                )}
                {lines && lines[1] && (
                    <TextoCard
                        ellipsis={props.ellipsis}
                        alinhamento={card.alinhamento}
                        tabCard={tabCard}
                        corTexto={card.corTexto}
                    >
                        {' '}
                        {
                            typeof lines[1] === 'string' ? <ReactMarkdown>{lines[1]}</ReactMarkdown> : lines[1]
                        }
                        {' '}
                    </TextoCard>
                )}
                {card.botao && (
                    <CtaContainer alinhamento={card.alinhamento}>
                        <BotaoCTA botao={card.botao} />
                    </CtaContainer>
                )}
                {card.link && (
                    <CardLink>
                        {card.link.rota && (
                            <a href={replaceVariableByValue(card.link.rota.endereco)} passHref>
                                <LinkDS> {card.link.label} </LinkDS>
                            </a>
                        )}
                        {card.link.arquivo && (
                            <a
                                href={replaceVariableByValue(card.link.arquivo.url)}
                                target="_blank"
                                download
                                rel="noopener noreferrer"
                            >
                                <LinkDS> {card.link.label} </LinkDS>
                            </a>
                        )}
                    </CardLink>
                )}
                {card.anotacoes && (
                    <Anotacao alinhamento={card.alinhamento}>
                        {' '}
                        <ReactMarkdown>{card.anotacoes}</ReactMarkdown>
                    </Anotacao>
                )}
            </ContainerText>
        </ContainerCard>
    )
}

Card.propTypes = {
    blog: PropTypes.bool,
    card: PropTypes.object,
    transparent: PropTypes.bool,
}
